// The entire purpose of this file is to delegate the LogRocket object to
// the one defined/instantiated in our HTML layouts and saved on window.
// You can import it into any React component and use it like normal.
// ie `import LogRocket from './log_rocket/main'`
const DevEnvLogRocketStub = {
  captureMessage: (error, extra_stuff) => { console.error(`Error: ${error}`, extra_stuff); },
  captureException: (error, extra_stuff) => { console.error(`Error: ${error}`, extra_stuff); }
};

export default (window.LogRocket || DevEnvLogRocketStub);

export const track = (userEvent) => {
  window.LogRocket && window.LogRocket.track(userEvent); // eslint-disable-line no-unused-expressions
};
